export default {
  title: 'Cum funcționează Estimator24',
  steps: [
    {
      title: 'Analiza pieței',
      description: 'Modelul analizează prețurile și tendințele din oraș'
    },
    {
      title: 'Evaluare',
      description: 'Primiți o evaluare automată a valorii proprietății'
    },
    {
      title: 'Analitică',
      description: 'În plus, vedeți comparabile, grafice și recomandări'
    },
    {
      title: 'Decizie',
      description: 'Pe baza datelor luați o decizie investițională sau personală'
    }
  ]
}
